var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "search-flex" },
    [
      _c(
        "div",
        [
          _c(
            "el-form",
            {
              attrs: {
                inline: true,
                model: _vm.searchParams,
                size: "small",
                "label-width": "88px",
              },
            },
            [
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    attrs: { placeholder: "提示名称" },
                    model: {
                      value: _vm.searchParams.templateName,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchParams, "templateName", $$v)
                      },
                      expression: "searchParams.templateName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "search-btn" },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "auth",
                  rawName: "v-auth",
                  value: "PROMPT_TEMPLATE_SEARCH",
                  expression: "'PROMPT_TEMPLATE_SEARCH'",
                },
              ],
              attrs: { type: "primary", size: "small" },
              on: {
                click: function ($event) {
                  return _vm.search(1)
                },
              },
            },
            [_vm._v("搜索")]
          ),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "auth",
                  rawName: "v-auth",
                  value: "PROMPT_TEMPLATE_ADD",
                  expression: "'PROMPT_TEMPLATE_ADD'",
                },
              ],
              attrs: { size: "small" },
              on: { click: _vm.add },
            },
            [_vm._v("新增")]
          ),
        ],
        1
      ),
      _c("EditDialog", {
        ref: "editDialog",
        on: {
          reload: function ($event) {
            return _vm.search()
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }